import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'

import { HiddenOnTrial, useAccount } from '@/modules/account'
import { useScreenerWebsocket } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute('/_authenticated/tools')({
  component: ToolsRoute,
})

function ToolsRoute() {
  return (
    <HiddenOnTrial>
      <ToolsLayout />
    </HiddenOnTrial>
  )
}

function ToolsLayout() {
  const account = useAccount()
  useScreenerWebsocket()

  // Wait for the account before deciding, then keep the section dark unless the
  // trustee's plan enables it.
  if (!account) return null
  if (!account.isToolsBankruptcyEnabled) {
    return <Navigate to="/" />
  }

  return <Outlet />
}
